import { createFetchTypes } from '../../utils/createFetchTypes';

export const SEARCH_DRUGS = 'SEARCH_DRUGS';
export const SET_DRUGS = 'SET_DRUGS';
export const ADD_PRESCRIPTION = 'ADD_PRESCRIPTION';
export const REMOVE_PRESCRIPTION = 'REMOVE_PRESCRIPTION';
export const REPLACE_PRESCRIPTION = 'REPLACE_PRESCRIPTION';

// ************* createFetchType

export const SET_PRESCRIPTIONS = createFetchTypes('SET_PRESCRIPTIONS');
